import { GOOGLE_CLICK_ID_PARAMS } from 'shared/presentation/constants';

type TGoogleClickIdParam = (typeof GOOGLE_CLICK_ID_PARAMS)[number];

export default function getGoogleClickIdentifier(
  entries: Iterable<[string, string | undefined]>,
): { googleId?: string; googleIdType?: TGoogleClickIdParam } {
  for (const [key, value] of entries) {
    if (!value) continue;

    if ((GOOGLE_CLICK_ID_PARAMS as readonly string[]).includes(key)) {
      return { googleId: value, googleIdType: key as TGoogleClickIdParam };
    }
  }

  return { googleId: undefined, googleIdType: undefined };
}
